import { Component, ViewChild } from '@angular/core';
import { Platform, NavController, Content, Events } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';

import { BarcodeScanner } from '@ionic-native/barcode-scanner';

import { User }    from '../../providers/user/user';
import { Utils }    from '../../providers/utils/utils';
import { Api }      from '../../providers/api/api';
import { IPTV }     from '../../providers/iptv/iptv';
import { Fav }      from '../../providers/fav/fav';
import { FavApp }   from '../../providers/favapp/favapp';
import { Gateway }  from '../../providers/gateway/gateway';
import { Deeplink } from '../../providers/deeplink/deeplink';
import { Services } from '../../providers/services/services';

import { TabsMain }  from '../tabsmain/tabsmain';

/*
*
*  Login Page
*
*/
@Component({
  selector: 'login',
  templateUrl: 'login.html'
})
export class Login {
    @ViewChild(Content) content: Content;

    /*
    *    Hook for API Instance
    */
    public hookAPI : any = {
        url   : '',
        count : 0
    }

    /*
    *    Login & pwd & hookAPI form object
    */
    public form : any = {};

    /*
    *    Global view state (loading -> form -> progression)
    */
    public global : any = {
        loaded: false,
        logged: false,
        known : false,
        forgot: false
    };

    /*
    *    Forgot attributew
    */
    public forgot : any = {
        view : 'get',
        data : {}
    }


    /*
    *    Progression main Object
    */
    public progress : any = {
        timeout : 500,
        position:0,
        title : 'Authenticated',
        error : ''
    }

    // Keyboard logo hide
    public isKeyboardVisible : boolean = false;

    // Rand for video
    public rand : number = 2+(Math.floor(Math.random() * Math.floor(99999)));

    // Relaunch init on awaitingDeeplink
    public awaitingDeeplink : boolean = false;

    /*
    *    Construction
    */
    constructor(
        public platform: Platform,
        private navCtrl: NavController, 
        private barcodeScanner: BarcodeScanner,
        private utils: Utils,
        private events: Events,
        private user: User,
        public IPTV: IPTV,
        public api: Api,
        public services: Services,
        public gateway: Gateway,
        public fav: Fav,
        public favApp: FavApp,
        public deepLink: Deeplink
    ) { 
        Observable.fromEvent(window, 'keyboardWillShow').subscribe(() => {
            this.isKeyboardVisible=true;
        });

        Observable.fromEvent(window, 'keyboardWillHide').subscribe(() => {
            this.isKeyboardVisible=false;
        });

        // On resume
        this.platform.resume.subscribe(() => {
            if (this.awaitingDeeplink) {
                this.init();
            }
        });

    }

    /*
    *    When view load
    */
    ionViewDidLoad() {
        this.init();
        this.initEvents();
    }

    /*
    *    Init launched first
    */
    init () {
        this.resetHooks();

        this.platform.ready().then(() => {
            this.checkInit();
        });
    }

    /*
    *    Events catcher
    */
    initEvents() {
        // Reset global variables on disconnect
        this.events.subscribe('user:disconnect', (params : any = {}) => { 
            this.resetView();
        });
    }

    /*
    *    Reset view, like the first time (view loaded -> show login)
    */
    resetView() {
        this.global = {};
        this.global.loaded = true;
        this.global.logged = false;
        this.global.forgot = false;
        this.global.known  = false;
        this.global.knownLoad  = false;
        this.forgot  = {
            view : 'get',
            data : {}
        }
        this.form = {};
        this.resetHooks();
    }

    /*
    *    Reset Hooks (after platform resume, or disconnection)
    */
    resetHooks() {
        this.hookAPI.count = 0;
        this.hookAPI.url = localStorage.getItem('hookAPIURL');

        if (this.hookAPI.url) {
            this.hookAPI.count = 15;
        }
    }

    /*
    *    If present, set Api Hook
    */
    setHookApi()
    {
        if (this.hookAPI.url) localStorage.setItem('hookAPIURL', this.hookAPI.url);
        else localStorage.removeItem('hookAPIURL');
    }

    /*
    *    Main Connection method (login & password)
    */
    connect() {
        // Empty
        if (!this.form.login || !this.form.password) {
            this.utils.error('Please provide your username and password.');
            return false;
        }

        // Set loader
        this.utils.load('','bg-transparent');

        // Set hook for api
        this.setHookApi();

        // Call API
        this.user.auth(this.form.login, this.form.password).then(() => {

            // Check IPTV Status
            this.checkAfterAuth();

        }, (err) => {
            // Error
            this.utils.unload();
            this.utils.error(err);
        });
    }

    /*
    *    Second Connection method (if Airmont Gateway, only for Guest)
    */
    connectGuest() {
        // Set loader
        this.utils.load('','bg-transparent');

        // Set hook for api
        this.setHookApi();

        // Get Airmont Gateway creditentials
        this.gateway.getCreditentials().then((response : any = {}) => {

            // Call API
            this.user.authGuest(response.login, response.password).then(() => {

                // Check IPTV Status
                 this.checkAfterAuth();

            }, (err) => {
                // Error
                this.utils.unload();
                this.utils.error(err);
            });

        }, (err) => {
            // Error
            this.utils.unload();
            this.utils.error('Authentification failed');
        });
    }

    /*
    *    Third Connection method (if Airmont Gateway, from QrCode Scanning)
    */
    connectQRCode() {

        let that = this;

        // Set loader
        that.utils.load('','bg-transparent');

        // Launching Barcode Scanner
        this.barcodeScanner.scan().then(barcodeData => {

            if (barcodeData.cancelled) {
                that.utils.unload();
                return false;
            }
            
            if (barcodeData.text != 'AirmontGatewayAdminConnect') {
                that.utils.unload();
                that.utils.error('QRCode not recognized');
                return false;
            } 

            // Set hook for api
            that.setHookApi();

            // Get Airmont Gateway creditentials
            that.gateway.getCreditentialsAdmin().then((response : any = {}) => {
                // Call API
                that.user.authCode(response.login, response.password).then(() => {

                    // Check IPTV Status
                     that.checkAfterAuth();

                }, (err) => {
                    // Error
                    that.utils.unload();
                    that.utils.error(err);
                });

            }, (err) => {
                // Error
                that.utils.unload();
                that.utils.error('Cannot communicate with Airmont Gateway');
            });
            
        }).catch(err => {
            that.utils.unload();
        });

    }

    /*
    *    Known user connection after deallocution
    */
    connectKnown() {
        this.api.clearCache();
        let that = this;

        this.global.loaded = false;
        this.global.logged = false;
        this.global.known  = false;
        this.global.knownLoad = true;

        setTimeout(function() {
            that.checkAfterAuth();
        }, 100);
    }


    /*
    *    Check user Status on Page INIT (first time or back to login, after disconnect)
    */    
    checkInit() {
        
        // Start deeplink
        this.events.publish('deeplink:watch');

        // Stop if user disconnection not finished
        if (this.user.isDisconnecting) {
            this.global.loaded = true;
            this.global.logged = false;
            this.global.known  = false;
            return false;
        }

        // Check User if has token
        this.user.fetch().then(() => {
    
            // Check User IPTV Environnement
            this.IPTV.init(0).then(() => {

                // Prefetch fav
                this.prefetchFav();

                // Check encoder status
                this.services.check().then(() => {

                    // Progression view
                    this.global.loaded = true;
                    this.global.logged = true;
                    this.global.known  = false;

                    // Set Progression view
                    this.setSilentProgression();

                    // Publish Logged events
                    this.events.publish('user:login');

                    // Remove awaitingDeeplink
                    this.awaitingDeeplink = false;

                }, (err) => {
                    
                    
                    if (this.deepLink.awaitingDeeplink && localStorage.getItem('token')) {
                        this.utils.log('Login:checkInit::AwaitedDeeplink');
                        // Auto connect
                        this.connectKnown();

                        this.awaitingDeeplink = false;

                    } else {
                        this.utils.log('Login:checkInit::NoAwaitDeeplink');
                        // Set known view
                        this.global.loaded = true;
                        this.global.logged = false;

                        if (localStorage.getItem('token')) {
                            this.global.known  = true;
                        }

                        this.awaitingDeeplink = true;

                        // Reset IPTV Data
                        this.IPTV.resetData();
                    }
                });

            }, (err) => {
                
                // Reset View to login 
                this.global.loaded = true;
                this.global.logged = false;
                this.global.known  = false;
        
                // Disconnect user if token stocked
                this.user.disconnect(true).then( () => {
                    // Publish Disconnect events
                    this.events.publish('iptv:off');
                });
                
            });
            
        }, (err) => {
    
            // If Error Reset view to Login
            this.global.loaded = true;
            this.global.logged = false;
            this.global.known  = false;
        });
        
    }

    /*
    *    Check user Status AFTER manual AUTH METHOD
    */ 
    checkAfterAuth() {

        // Api Call for User information
        this.user.fetch().then(() => {

            // Check User IPTV Environnement
            this.IPTV.init(500).then(() => {

                // Prefetch fav
                this.prefetchFav();
                
                // Unload 
                this.utils.unload();

                // Set Progression view 
                this.global.loaded = true;
                this.global.logged = true;
                this.global.known  = false;
                this.global.knownLoad  = false;

                // Send logged events
                this.events.publish('user:login');

                // Set Progression view
                this.setProgression();
            }, (err) => {

                // Unload 
                this.utils.unload();

                // Kill token
                this.user.disconnect(true).then( () => {
                    this.events.publish('iptv:off');
                });

                // Set Progression view 
                this.global.loaded = true;
                this.global.logged = true;
                this.global.known  = false;
                this.global.knownLoad  = false;

                // Set Progression view
                this.setProgression();

            });
        }, (err) => {

            // Error on user, directly fallback to login
            this.user.disconnect(true).then( () => {

                // Unload 
                this.utils.unload();

                // Set Login Page
                this.global.loaded = true;
                this.global.logged = false;
                this.global.known  = false;
                this.global.knownLoad  = false;

                // Show error
                this.utils.error(err);
            });
        });
    }

    /*
    *    Progression, pyramidal progression bar
    */
    setProgression() {

        let that = this;

        // Reset error 
        that.progress.error = false;

        // Start Progression bar 
        this.startProgressionBar();
        
        // Authentificated
        this.progress.title = '<br>Authenticated';

        // Contract
        if (this.IPTV.contract
            && this.IPTV.contract.contract
            && this.IPTV.contract.contract.reference) {
            setTimeout(function() { 

                that.progress.title = '<br>Contract validation in progress';

                // Subscription
                if (that.IPTV.contract
                    && that.IPTV.contract.subscription
                    && that.IPTV.contract.subscription.reference) {
                    setTimeout(function() { 

                        that.progress.title = '<br>Suscription validation in progress';

                        // Encoder
                        if (that.IPTV.encoder && that.IPTV.encoder.name) {
                            setTimeout(function() { 
                                
                                that.progress.title = '<br>Encoder(s) assignment in progress';

                                // Sources
                                if (that.IPTV.boxs && that.IPTV.boxs.length) {
                                    setTimeout(function() { 

                                        that.progress.title = '<br>Source(s) assignment in progress';

                                        //  Source
                                        if (that.IPTV.box && that.IPTV.box.name) {
                                           setTimeout(function() { 
                                                that.progress.title = '<br>Current source detected';

                                               // Resolution
                                               if (that.IPTV.resolution && that.IPTV.resolution.name) {
                                                   setTimeout(function() { 

                                                        that.progress.title = '<br>Current profile detected';

                                                        setTimeout(function() {
                                                            
                                                            that.progress.title = '<br>Launching Airmont Remote App';

                                                            setTimeout(function() {
                                                               that.start(true);
                                                            }, that.progress.timeout);
                                                       }, that.progress.timeout);

                                                   }, that.progress.timeout);
                                               }  else {
                                                    that.IPTV.reset();
                                                    that.user.disconnect(true).then( () => {
                                                        that.events.publish('iptv:off');
                                                    });
                                                   setTimeout(function() { that.progress.error = 'Current profile not found'; }, that.progress.timeout);
                                               }
                                           }, that.progress.timeout);
                                       }  else {
                                            that.IPTV.reset();
                                            that.user.disconnect(true).then( () => {
                                                that.events.publish('iptv:off');
                                            });
                                           setTimeout(function() { that.progress.error = 'Current source not found'; }, that.progress.timeout);
                                       }
                                    }, that.progress.timeout);
                                }  else {
                                    that.IPTV.reset();
                                    that.user.disconnect(true).then( () => {
                                        that.events.publish('iptv:off');
                                    });
                                    setTimeout(function() { that.progress.error = 'Source(s) not available'; }, that.progress.timeout);
                                }
                            }, that.progress.timeout);
                        }  else {
                            that.user.disconnect(true).then( () => {
                                that.events.publish('iptv:off');
                            });
                            setTimeout(function() { that.progress.error = 'Encoder(s) not available'; }, that.progress.timeout);
                        }
                    }, that.progress.timeout);
                }  else {
                    that.user.disconnect(true).then( () => {
                        that.events.publish('iptv:off');
                    });
                    setTimeout(function() { that.progress.error = 'Subscription not valid';}, that.progress.timeout);
                }
             }, that.progress.timeout);
        }  else {
            that.user.disconnect(true).then( () => {
                that.events.publish('iptv:off');
            });
            setTimeout(function() { that.progress.error = 'Contract not valid'; }, that.progress.timeout);
        }
        
    }

    setSilentProgression() {

        // Contract
        if (this.IPTV.contract
            && this.IPTV.contract.contract
            && this.IPTV.contract.contract.reference) {
                // Subscription
                if (this.IPTV.contract
                    && this.IPTV.contract.subscription
                    && this.IPTV.contract.subscription.reference) {
                        // Encoder
                        if (this.IPTV.encoder && this.IPTV.encoder.name) {
                                // Sources
                                if (this.IPTV.boxs && this.IPTV.boxs.length) {
                                        //  Source
                                        if (this.IPTV.box && this.IPTV.box.name) {
                                               // Resolution
                                               if (this.IPTV.resolution && this.IPTV.resolution.name) {
                                                    this.utils.unload();
                                                    this.start();
                                               }  else {
                                                    this.IPTV.reset();
                                                    this.user.disconnect(true).then( () => {
                                                        this.events.publish('iptv:off');
                                                    });
                                                    this.resetView();
                                                    this.utils.error('Current profile not found');
                                               }
                                        }  else {
                                            this.IPTV.reset();
                                            this.user.disconnect(true).then( () => {
                                                this.events.publish('iptv:off');
                                            });
                                            this.resetView();
                                            this.utils.error('Current source not found');
                                        }
                                }  else {
                                    this.IPTV.reset();
                                    this.user.disconnect(true).then( () => {
                                        this.events.publish('iptv:off');
                                    });
                                    this.resetView();
                                    this.utils.error('Source(s) not available');
                                }
                        }  else {
                            this.resetView();
                            this.user.disconnect(true).then( () => {
                                this.events.publish('iptv:off');
                            });
                            this.utils.error('Encoder(s) not available');
                        }
                }  else {
                    this.resetView();
                    this.user.disconnect(true).then( () => {
                        this.events.publish('iptv:off');
                    });
                    this.utils.error('Subscription not valid');
                }
        }  else {
            this.resetView();
            this.user.disconnect(true).then( () => {
                this.events.publish('iptv:off');
            });
            this.utils.error('Contract not valid');
        }
    } 


    /*
    *    Begin Remote at 100% Of Progression
    */
    start(realLogin?:boolean) {
        
        // Call Script on Login
        if (realLogin) {
            // Set ScriptSource
            this.IPTV.setScriptSource();
            this.IPTV.setScriptResolution();
            this.IPTV.setDefaultVolume();
            this.IPTV.setDefaultChannel();
            this.IPTV.setConnectionScripts();
        }

        // Page par défault (si Guest OU si il as des favoris ou non (a venir))
        if (this.user.isGuest()) {
            this.navCtrl.setRoot(TabsMain, {setIndex:0});
        } else {
            if (!this.fav.empty || !this.favApp.empty) {
                this.navCtrl.setRoot(TabsMain, {setIndex:1});
            } else {
                this.navCtrl.setRoot(TabsMain, {setIndex:0});
            }
        }

        // Set Startings events
        this.events.publish('iptv:on');
    }


    /*
    *    Start Progression Bar, same time of progress Title
    */
    startProgressionBar() {

        let that = this;

        var i = 0;

        setInterval(function() {
            if (that.progress.error) {
                i = 0;
                return false;
            }

            if (i > 99) return false;
            i = i+1;
            that.progress.position = i;

        }, 40);
    }

    /*
    *     Pre-fetch fav
    */
    prefetchFav() {
        this.fav.fetch(true);
        this.favApp.fetch(true);
    }


    /*
    *    Get Code From Email
    */
    getCode() {

        if (!this.form.email) return false;
        
        this.utils.load('','bg-transparent');

        this.api.get('forgotPassword', {email:this.form.email}).subscribe((response:any)=>{
            this.utils.unload();

            if (response.status == 400) {
                this.utils.error(response.errorMessage);
            } else {

                this.forgot.data.rand  = response.result.mt_rand;
                this.forgot.data.id    = response.result.id;
                this.forgot.data.token = response.result.token;
                this.forgot.view = 'check';
            }
            
        },(err) => {
            this.utils.unload();
            this.utils.error(this.api.reject(err));
        });
    }

    checkCode() {

        if (!this.form.rand) return false;

        if (this.form.rand != this.forgot.data.rand) {
            this.utils.error('Invalid code');
        } else {
            this.forgot.view = 'save';
        }
    }


    savePassword() {

        if (!this.form.password || !this.form.password_confirm) {
            return false;
        }

        if (this.form.password != this.form.password_confirm) {
            this.utils.error('Your password doesnt match confirmation');
            return false;
        }
        this.utils.load('','bg-transparent');

        let params = {
            'password'          : this.form.password,
            'password_confirm'  : this.form.password_confirm,
            'id'                : this.forgot.data.id,
            'token'             : this.forgot.data.token
        }

        this.api.post('forgotPassword', params).subscribe((response:any)=>{
            this.utils.unload();
            if (response.status == 400) {
                this.utils.error(response.errorMessage);
            } else {
                this.forgot.view = 'done';
            }
            
        },(err) => {
            this.utils.unload();
            this.utils.error(this.api.reject(err));
            this.form.password = '';
            this.form.password_confirm = '';
        });

    }

    enableKeyboardVisible() {
        if (!this.utils.isBrowser()) this.isKeyboardVisible = true;
    }

    disableKeyboardVisible() {
        if (!this.utils.isBrowser()) this.isKeyboardVisible = false;
    }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts